import type { Content } from '../../interface/Content';
import type { Paginated } from '@/interface/Paginate';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getKeepWatching = async (context: Context, types?: string) => {
  try {
    const { data } = await api.get<Paginated<Content>>(mapContext[context], {
      params: { types },
    });
    return data.data;
  } catch (error) {
    return [];
  }
};

export const useGetKeepWatching = (
  context: Context = 'home',
  types?: string
) => {
  const authToken = getCookie(authKeys.authToken);
  return useQuery({
    queryKey: ['keep', 'watching', context, types],
    queryFn: () => getKeepWatching(context, types),
    enabled: !!authToken,
  });
};

const mapContext = {
  home: apiConfig.routes.entertainment.content.keepWatching,
  research: apiConfig.routes.research.keepWatch,
} as const;

type Context = keyof typeof mapContext;
